import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const PORTAL_TOKEN_KEY = "anila_portal_token";
const PORTAL_ROLE_KEY = "anila_portal_role";

export const portalAuth = {
  getToken() {
    return localStorage.getItem(PORTAL_TOKEN_KEY);
  },
  getRole() {
    return localStorage.getItem(PORTAL_ROLE_KEY);
  },
  isAuthed() {
    return Boolean(localStorage.getItem(PORTAL_TOKEN_KEY));
  },
  isAdmin() {
    return localStorage.getItem(PORTAL_ROLE_KEY) === "admin";
  },
  setSession(token, role) {
    localStorage.setItem(PORTAL_TOKEN_KEY, token);
    localStorage.setItem(PORTAL_ROLE_KEY, role);
  },
  clear() {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    localStorage.removeItem(PORTAL_ROLE_KEY);
  },
};

export const portalApi = axios.create({ baseURL: API });

portalApi.interceptors.request.use((config) => {
  const token = portalAuth.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

portalApi.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      portalAuth.clear();
    }
    return Promise.reject(err);
  }
);

export function streamUrl(videoId) {
  const token = portalAuth.getToken();
  return `${API}/portal/stream/${videoId}?token=${encodeURIComponent(token || "")}`;
}
